import Modal from '@studiometa/js-toolkit/components/Modal';
import axios from 'axios';
import FormDl from './FormDl';
import Cache from '../utils/Cache';

const HTML = document.querySelector('html');

/**
 * Homepage class.
 */
export default class Popin extends Modal {
  /**
   * Class cofnig
   * @type {Object}
   */
  static config = {
    ...Modal.config,
    name: 'Popin',
    components: {
      FormDl,
    },
  };

  /**
   * Cache instance for the Ajax requests.
   * @type {Cache}
   */
  cache = new Cache({ name: 'Popin' });

  /**
   * Prevent defautl behavior when clicking on the open ref.
   */
  get onOpenClick() {
    return (event) => {
      HTML.classList.add('show-overlay');
      event.preventDefault();
      super.onOpenClick(event);
    };
  }

  /**
   * Override the parent open method to dynamically set the modal's content.
   */
  async open() {
    // Fetch content from src if defined
    if (this.$refs.open.href) {
      const content = await this.fetch(this.$refs.open.href);
      this.$refs.content.innerHTML = content;
      // Mount any newly inserted component
      this.$update();
    }
    return super.open();
  }

  /**
   * Fetch the content of the modal.
   *
   * @param {string} url
   * @return {string}
   */
  async fetch(url) {
    let content = this.cache.get(url);

    if (content) {
      return content;
    }

    content = await axios(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      params: {
        // eslint-disable-next-line camelcase
        is_ajax: true,
      },
    }).then((response) => {
      const data = document.createElement('div');
      data.innerHTML = response.data;
      return data.querySelector('.content').innerHTML;
    });

    this.cache.set(url, content);

    return content;
  }

  /** */
  onFormDlSuccess() {
    this.close();
  }

  /** */
  close() {
    super.close();
    setTimeout(() => {
      HTML.classList.remove('show-overlay');
    }, 200);
  }
}
